import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AccessControlProvider } from './contexts/AccessControlContext';
import { GuidesProvider } from './contexts/GuidesContext';
import LoginForm from './features/auth/components/LoginForm';
import RegisterForm from './features/auth/components/RegisterForm';
import { LanguageProvider } from './components/ItineraryCreator/LanguageContext';
import MainApp from './components/MainApp';
import NatalPage from './components/NatalPage';
import SimpleTTS from './components/SimpleTTS';
import TtsBenchmark from './components/TtsBenchmark';
import MuseumWelcomePage from './components/MuseumWelcomePage';
import MuseumInfoPage from './components/MuseumInfoPage';
import ClientOnboardingPublicPage from './components/ClientOnboardingPublicPage';

const AuthWrapper = () => {
  const { currentUser, logout } = useAuth();
  const [isLogin, setIsLogin] = useState(true);

  if (currentUser) {
    return (
      <AccessControlProvider>
        <GuidesProvider>
          {/* Wrap with LanguageProvider */}
          <LanguageProvider>
            <MainApp />
          </LanguageProvider>
        </GuidesProvider>
      </AccessControlProvider>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-50 to-electric-blue-muted/30 flex items-center justify-center p-4">
      {isLogin ? (
        <LoginForm onToggle={() => setIsLogin(false)} />
      ) : (
        <RegisterForm onToggle={() => setIsLogin(true)} />
      )}
    </div>
  );
};

function App() {
  // Check if we're on special pages
  const isNatalPage = window.location.pathname === '/natal' || window.location.pathname.includes('natal');
  const isBenchmarkPage = window.location.pathname === '/tts-benchmark';
  const isTTSPage = window.location.pathname === '/tts';
  const venuePrefixes = '(?:venue|museum|site|place|business|monument|m|v)';
  const qrVenueInfoMatch = window.location.pathname.match(/^\/qr\/([^/]+)\/info\/?$/i);
  const qrVenueMatch = window.location.pathname.match(/^\/qr\/([^/]+)\/?$/i);
  const clientOnboardingMatch = window.location.pathname.match(/^\/onboarding\/([^/]+)\/?$/i);
  const museumWelcomeMatch = window.location.pathname.match(new RegExp(`^\\/${venuePrefixes}\\/([^/]+)\\/?$`, 'i'));
  const museumInfoMatch = window.location.pathname.match(new RegExp(`^\\/${venuePrefixes}\\/([^/]+)\\/info\\/?$`, 'i'));

  if (isNatalPage) {
    return <NatalPage />;
  }

  if (isBenchmarkPage) {
    return <TtsBenchmark />;
  }

  if (isTTSPage) {
    return <SimpleTTS />;
  }

  if (qrVenueInfoMatch) {
    return <MuseumInfoPage museumId={decodeURIComponent(qrVenueInfoMatch[1])} />;
  }

  if (qrVenueMatch) {
    return <MuseumWelcomePage museumId={decodeURIComponent(qrVenueMatch[1])} />;
  }

  if (clientOnboardingMatch) {
    return <ClientOnboardingPublicPage clientId={decodeURIComponent(clientOnboardingMatch[1])} />;
  }

  if (museumInfoMatch) {
    return <MuseumInfoPage museumId={decodeURIComponent(museumInfoMatch[1])} />;
  }

  if (museumWelcomeMatch) {
    return <MuseumWelcomePage museumId={decodeURIComponent(museumWelcomeMatch[1])} />;
  }

  return (
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <AuthWrapper />
    </AuthProvider>
  );
}

export default App;
